const setup = () => {
  const menuClose = document.querySelector('.site-navigation__close-icon');
  const openMenu = document.querySelector('.toggle-menu');
  const menu = document.querySelector('.v2-menu-wrapper .site-navigation');
  const body = document.querySelector('body');
  const overlay = document.querySelector('.site-navigation__overlay');

  const navItems = document.querySelectorAll(
    '.v2-menu-wrapper ul.main-nav > li',
  );
  const menuBackground = document.querySelector('.menu-background');
  const screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  let menuHoverTimer;

  const closeMenu = e => {
    e.preventDefault();
    menu.classList.remove('site-navigation--visible');
    body.classList.remove('disable-scroll');
  };

  if (openMenu) {
    openMenu.addEventListener('click', e => {
      e.preventDefault();
      menu.classList.add('site-navigation--visible');
      body.classList.add('disable-scroll');
    });
  }

  if (menuClose) {
    menuClose.addEventListener('click', e => closeMenu(e));
    overlay.addEventListener('click', e => closeMenu(e));
  }

  if (menuBackground) {
    menuBackground.addEventListener('mouseenter', () => {
      menuBackground.classList.remove('show');
    });
  }

  for (let i = 0; i < navItems.length; i++) {
    const navItem = navItems[i];

    navItem.addEventListener('mouseenter', e => {
      menuHoverTimer = setTimeout(() => {
        menuBackground.classList.add('show');
      }, 250);
    });

    navItem.addEventListener('mouseleave', e => {
      const target = e.relatedTarget || e.toElement;
      if (target !== null) {
        if (
          target.classList.contains('divider-vertical') ||
          target.classList.contains('menu-background')
        ) {
          menuBackground.classList.add('show');
        } else {
          menuBackground.classList.remove('show');
        }
      }

      clearTimeout(menuHoverTimer);
    });
  }

  if (screenWidth < 768) {
    window.addEventListener('resize', handleMenuToggle);
  }

  const handleMenuToggle = () => {
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    if (width >= 768) {
      menu.classList.remove('site-navigation--visible');
      body.classList.remove('disable-scroll');
      window.removeEventListener('resize', handleMenuToggle);
    }
  };
};

export default setup;
